export default function getMarginBottomSm(value) {
  switch (value) {
    case -44:
      return "sm:-mb-44";
    case -40:
      return "sm:-mb-40";
    case -36:
      return "sm:-mb-36";
    case -32:
      return "sm:-mb-32";
    case -28:
      return "sm:-mb-28";
    case -24:
      return "sm:-mb-24";
    case -20:
      return "sm:-mb-20";
    case -16:
      return "sm:-mb-16";
    case -12:
      return "sm:-mb-12";
    case -8:
      return "sm:-mb-8";
    case -4:
      return "sm:-mb-4";
    case 0:
      return "sm:mb-0";
    case 1:
      return "sm:mb-1";
    case 2:
      return "sm:mb-2";
    case 3:
      return "sm:mb-3";
    case 4:
      return "sm:mb-4";
    case 5:
      return "sm:mb-5";
    case 6:
      return "sm:mb-6";
    case 7:
      return "sm:mb-7";
    case 8:
      return "sm:mb-8";
    case 9:
      return "sm:mb-9";
    case 10:
      return "sm:mb-10";
    case 12:
      return "sm:mb-12";
    case 14:
      return "sm:mb-14";
    case 16:
      return "sm:mb-16";
    case 20:
      return "sm:mb-20";
    case 24:
      return "sm:mb-24";
    default:
      return "";
  }
}
